<template>
  <section class="banners">
    <slide-show ref="slideshow" v-if="page.banners && page.banners.length">
      <div :key="image._id" class="slide" v-for="image in page.banners">
        <img :alt="image.alt" :src="image.image" />
      </div>
    </slide-show>
    <div class="caption" v-html="page.slogan" v-if="isHomePage"></div>
  </section>
</template>

<script>
import { mapState, mapGetters } from "vuex"

export default {
  name: "Banners",
  computed: {
    ...mapState(["page"]),
    ...mapGetters(["isHomePage"])
  }
}
</script>

<style scoped>
.strip {
  position: absolute;
  top: 0;
  height: 100%;
  right: 3%;
  z-index: 100;
}

.strip img {
  height: 100%;
}

.banners {
  z-index: 1;
  line-height: 0;
  clear: both;
  position: relative;
  overflow: hidden;
}

.cycle-slideshow {
  position: relative;
}

.cycle-slideshow .slide {
  display: none;
}

.cycle-slideshow .slide:first-child {
  display: block;
}

.banners img {
  opacity: 1;
}

.slide {
  width: 100%;
}

.slide img {
  width: 100%;
}

.caption {
  font-family: "Merriweather", serif;
  position: absolute;
  right: 3%;
  bottom: 7rem;
  width: 94%;
  font-size: 5rem;
  line-height: 1.2;
  z-index: 200;
  color: #fff;
  text-align: right;
}

.caption >>> span {
  white-space: nowrap;
  background: #bb9765;
  padding: 1rem 2rem;
  margin: 0.5rem 0;
  display: inline-block;
}

.caption div {
  margin-top: 3rem;
}

@media screen and (max-width: 1300px) {
  .caption {
    font-size: 3rem;
    bottom: 4rem;
  }
}
@media screen and (max-width: 1050px) {
  .banners {
    margin-top: 90px;
  }
}

@media screen and (max-width: 750px) {
  .caption {
    font-size: 2rem;
  }

  .caption div {
    margin-top: 1rem;
  }

  .strip {
    right: -30%;
  }

  .slide img {
    width: 150%;
    max-width: 150%;
    left: -25%;
    position: relative;
  }
}
</style>
